// Simple request coalescer to dedupe concurrent calls by key
// Usage: coalescer.run(key, asyncFn) -> Promise<T>

export class RequestCoalescer {
  constructor() {
    this._inflight = new Map(); // key -> Promise
  }

  run(key, fn) {
    if (!key) throw new Error('RequestCoalescer: key is required');
    if (this._inflight.has(key)) {
      return this._inflight.get(key);
    }
    const p = (async () => {
      try {
        return await fn();
      } finally {
        // Always clear, even on error, so future calls can proceed
        this._inflight.delete(key);
      }
    })();
    this._inflight.set(key, p);
    return p;
  }
}

export const coalescer = new RequestCoalescer();

